import { render } from "./HeroiconsOutlineMoon.vue?vue&type=template&id=71b3a147"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineMoon.vue"]])

export default __exports__